<div style="display:table" *ngIf="_Loaded" >
  <div style="display: table-row; height: 100vh;">
    <div style="width: 100%;  display: table-cell; vertical-align:middle; " >
      <div style="width: 60%; margin-left:20%; margin-right:20%; background-color: rgba(0, 0, 0, .60); color:white; padding: 1em; border-radius: 0.45em; text-align:justify;">
        <h1>About the Site</h1>
        <p>Of late I've begun reworking the original static site found at Assenheimers.com from the ground up to use a dynamic, data-driven approach in a modern responsive, Single Page Application (SPA) style.  
          <br/><br/>
          If you are a details-oriented individual you'll find what you need to know below:</p>
        <ul>
          <li *ngFor="let note of BuildInfo.BuildNotes; let MyIndex=index; let IsOdd=odd; let IsEven=even">
            {{note.BuildNote}}
          </li>          
          </ul>
          <p>This is a work in progress. We hope you've enjoyed the site. While you're taking it all in, we're going to keep climbing the mountain. Thanks for Visiting.</p>
        <div>
    </div>
  </div>
</div>
<div [style.background]="'url(./../../../../assets/images.background/NATURE.Dolomites.Mountains.Val.Gardena.Italy.Winter.jpg)'" [style.background-size]="'cover'" style="position: fixed; right: 0; bottom: 0; z-index: -100; width: auto; height: auto; background-repeat: no-repeat; background-size: cover; min-height: 100%; min-width: 100%;"></div>